import RecommerceScanner from "./RecommerceScanner";

export default RecommerceScanner;
